import { useCallback } from "react";
import { useEffect, useState } from "react";

export default function useModal() {
  // accept/reject state
  const [confirm, setConfirm] = useState(false);

  // hide/show modal state
  const [open, setOpen] = useState(false);

  // set modal name (it is required if you have multiple modal)
  const [modalName, setModalName] = useState(null);

  // set function to be run after confirmed (most be array)
  const [confirmedFunction, setConfirmedFunction] = useState(null);

  // set modalName and confirmedFn (optional)
  const openModalAndConfig = ({ modalName, confirmedFn }) => {
    setOpen(true);
    modalName && setModalName(modalName);
    confirmedFn && setConfirmedFunction(confirmedFn);
  };

  // handle confirmed function
  const confirmFunctionsHandler = useCallback(() => {
    if (confirm) {
      // run function state
      confirmedFunction && confirmedFunction.forEach((fn) => fn());

      // reset all states
      setOpen(false);
      setConfirm(false);
      setModalName(null);
      setConfirmedFunction(null);
    }
  }, [confirm, confirmedFunction]);

  useEffect(() => {
    confirmFunctionsHandler();
  }, [confirmFunctionsHandler]);

  return {
    confirm,
    setConfirm,
    open,
    setOpen,
    setModalName,
    modalName,
    setConfirmedFunction,
    openModalAndConfig,
  };
}
